import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowDownwardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_downward"}/>
}
